import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { registrationsApi, RegistrationApplicationForm } from "./registrationsApi";

export const useRegistrationApplicationForm = (studentId: number, courseId: number) => {
  const {
    data,
    isLoading,
    error,
    refetch: invalidate,
  } = useQuery({
    queryKey: ["registration-application-form", studentId, courseId],
    queryFn: () => registrationsApi.getApplicationForm(studentId, courseId),
    select: (response) => response.data,
    enabled: !!(studentId && courseId),
  });

  return {
    data: data || null,
    loading: isLoading,
    error,
    invalidate,
  };
};

export const useUpdateRegistrationField = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      studentId,
      courseId,
      fieldId,
      value,
    }: {
      studentId: number;
      courseId: number;
      fieldId: number;
      value: string;
    }) => registrationsApi.updateField(studentId, courseId, fieldId, { value }),
    onSuccess: (_, { studentId, courseId }) => {
      queryClient.invalidateQueries({
        queryKey: ["registration-application-form", studentId, courseId],
      });
      queryClient.invalidateQueries({
        queryKey: ["registrations"],
      });
    },
  });
};

export const useUpdateRegistrationForm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      studentId,
      courseId,
      fields,
    }: {
      studentId: number;
      courseId: number;
      fields: { fieldId: number; value: string }[];
    }) => registrationsApi.updateForm(studentId, courseId, { fields }),
    onSuccess: (_, { studentId, courseId }) => {
      queryClient.invalidateQueries({
        queryKey: ["registration-application-form", studentId, courseId],
      });
      queryClient.invalidateQueries({
        queryKey: ["registrations"],
      });
    },
  });
};